"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderSearch = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var checkbox_1 = require("../checkbox");
var dropdown_1 = require("../dropdown");
var list_1 = require("../list");
var tips_1 = require("../tips");
var util_1 = require("../util");
var getPlainText_1 = require("../_util/getPlainText");
var search_filter_1 = require("../_util/search-filter");
var text_highlight_1 = require("../_util/text-highlight");
var noop_1 = require("../_util/noop");
function getOptionPaths(data, all) {
    var optionPaths = [];
    var traverse = function (data, optionPath) {
        if (optionPath === void 0) { optionPath = []; }
        (data.options || []).forEach(function (option) {
            var options = tslib_1.__spread(optionPath, [option]);
            if (option.child) {
                if (all) {
                    optionPaths.push(options);
                }
                traverse(option.child, options);
            }
            else {
                optionPaths.push(options);
            }
        });
    };
    traverse(data);
    return optionPaths;
}
function filterPaths(paths, inputValue, filter) {
    return paths.filter(function (path) { return path.find(function (option) { return filter(inputValue, option); }); });
}
var defaultFilter = function (inputValue, _a) {
    var label = _a.label, value = _a.value;
    return search_filter_1.searchFilter(getPlainText_1.getPlainText(label) || value, inputValue);
};
function CascaderSearch(_a) {
    var data = _a.data, searchValue = _a.searchValue, onChange = _a.onChange, changeOnSelect = _a.changeOnSelect, multiple = _a.multiple, className = _a.className, style = _a.style, isSelected = _a.isSelected, _b = _a.filter, filter = _b === void 0 ? defaultFilter : _b, scheduleUpdate = _a.scheduleUpdate, tips = _a.tips, bottomTips = _a.bottomTips, onScrollBottom = _a.onScrollBottom, _c = _a.onSearch, onSearch = _c === void 0 ? noop_1.noop : _c;
    var _d = tslib_1.__read(react_1.useState(-1), 2), currentIndex = _d[0], setCurrentIndex = _d[1];
    react_1.useEffect(function () {
        setCurrentIndex(-1);
    }, []);
    var allOptionPaths = react_1.useMemo(function () { return getOptionPaths(data, changeOnSelect); }, [
        data,
        changeOnSelect,
    ]);
    react_1.useEffect(function () {
        onSearch(searchValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);
    var optionPaths = react_1.useMemo(function () { return filterPaths(allOptionPaths, searchValue, filter); }, [filter, searchValue, allOptionPaths]);
    react_1.useEffect(function () {
        if (scheduleUpdate) {
            scheduleUpdate();
        }
    }, [optionPaths, scheduleUpdate]);
    var classPrefix = util_1.useConfig().classPrefix;
    var _e = tslib_1.__read(react_1.useMemo(function () {
        return [
            tips ? tips(null, searchValue) : null,
            bottomTips ? bottomTips(null, searchValue) : null,
        ];
    }, [bottomTips, searchValue, tips]), 2), listTips = _e[0], listBottomTips = _e[1];
    return (react_1.default.createElement(dropdown_1.DropdownBox, { className: classnames_1.default(className, "size-auto-width"), style: style },
        react_1.default.createElement("div", { className: classPrefix + "-cascader-menu " + classPrefix + "-cascader-menu--thin" },
            react_1.default.createElement(list_1.List, { type: "option", className: multiple ? classPrefix + "-list--checkoption" : "", onScrollBottom: function () { return onScrollBottom(null, searchValue); } },
                !listTips && !listBottomTips && optionPaths.length === 0 && (react_1.default.createElement(list_1.List.StatusTip, null,
                    react_1.default.createElement(tips_1.EmptyTip, null))),
                listTips && react_1.default.createElement(list_1.List.StatusTip, null, listTips),
                optionPaths.map(function (options, index) {
                    var valuePath = options.map(function (_a) {
                        var value = _a.value;
                        return value;
                    });
                    var selected = isSelected && isSelected(valuePath);
                    var item = options.map(function (_a, i) {
                        var label = _a.label, value = _a.value;
                        var content = text_highlight_1.highlight(label, searchValue);
                        if (i === 0) {
                            return react_1.default.createElement(react_1.Fragment, { key: i + "-" + value }, content);
                        }
                        return (react_1.default.createElement(react_1.Fragment, { key: i + "-" + value },
                            " / ",
                            content));
                    });
                    return (react_1.default.createElement(list_1.List.Item, { key: valuePath.join("$"), current: currentIndex === index, onClick: function (event) {
                            return !multiple &&
                                onChange(valuePath, { event: event, options: options, selected: !selected });
                        } }, multiple ? (react_1.default.createElement(checkbox_1.Checkbox, { value: selected, onClick: function (event) {
                            return onChange(valuePath, {
                                event: event,
                                options: options,
                                selected: !selected,
                            });
                        } }, item)) : (item)));
                }),
                listBottomTips && react_1.default.createElement(list_1.List.StatusTip, null, listBottomTips)))));
}
exports.CascaderSearch = CascaderSearch;
CascaderSearch.displayName = "CascaderSearch";
//# sourceMappingURL=CascaderSearch.js.map